import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Location\GetLocationByIdController::__invoke
* @see app/Http/Controllers/Location/GetLocationByIdController.php
* @route '/api/location/{location}'
*/
const GetLocationByIdController = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetLocationByIdController.url(args, options),
    method: 'get',
})

GetLocationByIdController.definition = {
    methods: ["get","head"],
    url: '/api/location/{location}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Location\GetLocationByIdController::__invoke
* @see app/Http/Controllers/Location/GetLocationByIdController.php
* @route '/api/location/{location}'
*/
GetLocationByIdController.url = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { location: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { location: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            location: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        location: typeof args.location === 'object'
        ? args.location.id
        : args.location,
    }

    return GetLocationByIdController.definition.url
            .replace('{location}', parsedArgs.location.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Location\GetLocationByIdController::__invoke
* @see app/Http/Controllers/Location/GetLocationByIdController.php
* @route '/api/location/{location}'
*/
GetLocationByIdController.get = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetLocationByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Location\GetLocationByIdController::__invoke
* @see app/Http/Controllers/Location/GetLocationByIdController.php
* @route '/api/location/{location}'
*/
GetLocationByIdController.head = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetLocationByIdController.url(args, options),
    method: 'head',
})

export default GetLocationByIdController